


















import { Component, Mixins } from 'vue-property-decorator'
import EditMainUserDialog from '@/components/settings/account/settings-user/main-user/edit-main-user-dialog/EditMainUserDialog.vue'
@Component({
  components: {
    EditMainUserDialog,
  },
})
export default class MainUser extends Mixins() {
  editMainUserDialogIsOpen = false
}
